import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import icon from '../../images/icon/magic.svg';
import gImg1 from '../../images/logo-fff.png';
import Seo from '../../components/Seo';

const PrivacyPolicy = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return (
        <Fragment>
            <Seo 
                title={`${t('privacy.title')} | Orbitronix`}
                description={t('privacy.collect.body')}
                url={`/${lang || 'en'}/privacy-policy`}
            />
            <Layout>
                {/* Hero Section with Animation */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="page-title pt-150 pos-rel bg_img"
                >
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div 
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.3 }}
                                        className="page-title-box"
                                    >
                                        <motion.span 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5 }}
                                            className="sub-title"
                                        >
                                            <img src={icon} alt="" /> {t('privacy.title')}
                                        </motion.span>
                                        <motion.h2 
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="title"
                                        >
                                            {t('privacy.heading')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                                <div className="col-lg-3 mt-30 justify-content-center d-flex">
                                    <motion.div 
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.9, duration: 0.5 }}
                                        className="sd-right-img pos-rel"
                                    >
                                        <img src={gImg1} alt="" />
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Content Section with Animation */}
                <motion.section 
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="terms&conditions-section pt-85 pb-85 cp-det-bg"
                >
                    <div className="container">
                        <div className="terms-section_inner">
                            <div className="row">
                                <div className="col-lg-12">
                                    <motion.div 
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.7, duration: 0.6 }}
                                        className="item-details-widget" 
                                        style={{ padding: '50px 50px 60px 50px' }}
                                    >
                                        <p className="mb-4" style={{ opacity: 0.8, fontStyle: 'italic' }}>{t('privacy.lastUpdated')}</p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }} className="mb-20">
                                            1. {t('privacy.collect.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.9 }} className="mb-30">
                                            {t('privacy.collect.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0 }} className="mb-20">
                                            2. {t('privacy.use.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1 }} className="mb-30">
                                            {t('privacy.use.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }} className="mb-20">
                                            3. {t('privacy.security.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.3 }} className="mb-30">
                                            {t('privacy.security.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4 }} className="mb-20">
                                            4. {t('privacy.cookies.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }} className="mb-30">
                                            {t('privacy.cookies.body')}
                                        </motion.p>

                                        <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.6 }} className="mb-20">
                                            5. {t('privacy.contact.title')}
                                        </motion.h3>
                                        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.7 }}>
                                            {t('privacy.contact.body')}
                                        </motion.p>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default PrivacyPolicy;
